export const FILTER_TYPE = {
  INSTITUTION: 'institutions',
  FULLNAME: 'fullname',
  USERNAME: 'username',
  STATUS: 'status',
};
